<template>
	<el-main class="center-wrap info">
		<h3>个人信息</h3>
		<div class="uinfo-box flexStart">
			<div class="uinfo-wrap flexStart">
				<div class="avatar-box flexCenter">
					<el-avatar :size="150">
						<img v-if="!form.avatarUrl" alt="" height="150" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" width="150" />
						<img v-else :src="form.avatarUrl" height="150" onerror="this.url='https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'" width="150" />
					</el-avatar>
				</div>
				<div class="uinfo-tbox">
					<h3 style="word-break: break-all">{{ uinfo.nickName }}</h3>
					<div class="user-time" style="color: #b0b0b0">{{ uinfo.createTime | time }}</div>
					<el-link type="primary" @click="goto({ path: '/UserCenter/UserAccount' })"> 修改个人资料 <i class="el-icon-arrow-right"></i> </el-link>
				</div>
			</div>
			<div class="uinfo-idbox">
				<dl class="flexStart" style="align-items: baseline">
					<dt>用户账号：</dt>
					<dd class="htitle">
						<label style="margin-right: 12px">{{ uinfo.consumerCode }} </label>
						<!-- <i title="点击可复制" class="el-icon-copy-document" style="cursor: pointer;" @click="copyCode"></i> -->
						<!-- <p style="color:#909399; font-size: 12px; margin: 0">说明：此账号为网站登录账号，可搭配密码登录使用。</p> -->
					</dd>
				</dl>
				<!-- <dl class="flexStart" v-if="!uinfo.levelId  && !uinfo.levelEnd">
					<dt>账户类型：</dt>
					<dd class="htitle">普通用户<el-button style="margin-left: 10px;" size="mini" type="warning" @click="handleVipBuy"> 开通会员</el-button></dd>
				</dl> -->

				<!-- <div class="flexStart" v-if="uinfo.levelId && uinfo.levelEnd">
					<dt>会员等级：</dt>
					<dd class="htitle" ><el-tag effect="dark" type="warning" size="small">会员用户</el-tag></dd>
				</div>  -->

				<dl class="flexStart">
					<dt>会员等级：</dt>
					<dd style="display: flex; align-items: center" class="htitle" v-if="uinfo.levelId == 0">
						普通会员<el-button style="margin-left: 10px" size="mini" type="warning" @click="handleVipBuy">升级VIP</el-button>
					</dd>
					<dd class="htitle" v-if="uinfo.levelId > 0">
						VIP会员
					</dd>
				</dl>
				<dl class="flexStart" v-if="uinfo.levelId > 0">
					<dt>VIP到期时间：</dt>
					<dd style="display: flex; align-items: center" class="htitle">{{ uinfo.levelEnd }}<el-button style="margin-left: 10px" size="mini" type="warning" @click="handleVipBuy">续费VIP</el-button></dd>
				</dl>
				<dl class="flexStart">
					<p class="flexStart" style="color: #909399; font-size: 12px; margin: 0">说明：点击导航栏<el-link  style="margin-left: 0; font-size: 13px; padding: 0 2px" @click="showVipInfo">会员权益</el-link>查看VIP权益内容</p>
				</dl>

				<!-- <dl class="flexStart">
					<dt>绑定手机：</dt>
					<dd v-if="ruinfo.consumerPhone" class="htitle">{{ ruinfo.consumerPhone }}</dd>
					<dd v-if="!ruinfo.consumerPhone">未绑定</dd>
				</dl>
				<dl class="flexStart">
					<dt>绑定邮箱：</dt>
					<dd v-if="ruinfo.consumerEmail" class="htitle">{{ ruinfo.consumerEmail }}</dd>
					<dd v-if="!ruinfo.consumerEmail">未绑定</dd>
				</dl> -->
				<!-- <dl class="flexStart">
					<dt>绑定微信：</dt>
					<dd v-if="ruinfo.consumerEmail" class="htitle">{{ ruinfo.consumerEmail }}</dd>
					<dd v-if="!ruinfo.consumerEmail">未绑定</dd>
				</dl> -->
			</div>
		</div>

		<!-- <div class="extinfo-box">
			<h3>绑定账号</h3>
			<div class="extinfo-content tc">
				<div class="info-card-wp">
					<div type="warning-middle" class="info-card-icon"></div>
					<div class="info-card-content">
						<div class="info-card-content-title">绑定邮箱</div>
						<div class="info-card-content-info">未绑定邮箱</div>
					</div>
					<div type="warning-middle" class="info-card-btn">去绑定</div>
				</div>
			</div>
		</div> -->

		<UserInfoBox ref="infobox"></UserInfoBox>
		<UserExtBox ref="extbox"></UserExtBox>
		<!--// 绑定手机 -->
		<BdMobileBox ref="bdmobilebox"></BdMobileBox>
		<VIPInfo ref="VIPInfoDom"></VIPInfo>
	</el-main>
</template>

<script>
import { mapGetters } from 'vuex';
import UserInfoBox from '@/components/User/InfoBox.vue';
import UserExtBox from '@/components/User/ExtBox.vue';
import BdMobileBox from '@/components/User/BdMobileBox.vue';
import User from '@/utils/User';
import CopyText from '@/utils/CopyText';
import VIPInfo from '@/components/PageHeader/VIPInfo.vue';

// import { getVipInfo, postOrderVipBuy } from '@/api/vip/vip.js';

export default {
	data() {
		return {
			form: {}
		};
	},

	computed: {
		ruinfo() {
			let uinfo = this.uinfo;
			uinfo.mobile = uinfo.mobile || '<span class="no-data">未绑定</span';
			uinfo.mobile = uinfo.mobile || '<span class="no-data">未绑定</span';
			uinfo.email = uinfo.email || '<span class="no-data">未绑定</span';

			return uinfo;
		},

		...mapGetters('User', ['uinfo'])
	},
	components: {
		UserInfoBox,
		UserExtBox,
		BdMobileBox,
		VIPInfo
	},
	created() {
		this.form = JSON.parse(localStorage.getItem('userinfo'));
		if (this.form.avatar) {
			this.getFilesInfo(this.form.avatar);
		}
	},
	filters: {
		time() {
			const now = new Date();
			const hour = now.getHours();
			if (hour < 12) {
				return '上午好';
			} else if (hour < 18) {
				return '下午好';
			} else {
				return '晚上好';
			}
		}
	},
	methods: {
		showVipInfo() {
			this.$router.push('/VIPList');
		    // this.$refs.VIPInfoDom.dialogVisible = true;
		},
		handleVipBuy() {
			const targetRoute = this.$router.resolve({
				path: '/VIPList',
			});
			window.open(targetRoute.href, '_blank');
		},

		copyCode() {
			CopyText.copyMessage(this.uinfo.consumerCode);
		},

		// 获取文件详情
		async getFilesInfo(url) {
			try {
				const prefix = '/third/files/info/';
				const key = url.replace(prefix, '');
				const response = await fetch(`/webL_api/third/files/info/${key}`, {
					headers: {
						Authorization: 'Bearer ' + User.getToken()
					}
				});
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				const arrayBuffer = await response.arrayBuffer();
				// 创建Blob对象，使用更具体的MIME类型
				const blob = new Blob([arrayBuffer], { type: 'image/jpeg' });
				// 生成可用的URL
				const imageUrlData = URL.createObjectURL(blob);
				this.$set(this.form, 'avatarUrl', imageUrlData);
			} catch (error) {
				console.error('获取图片失败:', error);
				return null;
			}
		},

		// 绑定手机
		openBox() {
			this.$refs.bdmobilebox.open();
		},

		// 打开编辑窗口
		openEditBox() {
			this.$refs.infobox.open();
		},

		// 打开完善信息窗口
		openExtBox() {
			this.$refs.extbox.open();
		},

		// 加载订单量折线图
		load() {
		}
	}
};
</script>

<style lang="less" scoped>
.info {
	padding: 30px 20px;
}
.uinfo-box {
	padding: 30px;
	font-size: 14px;
	background-color: rgba(227, 238, 255, 1);
	border-radius: 3px;
}
.uinfo-wrap {
	flex: 1 1;
	.avatar-box {
		margin-right: 12px;
		border: 5px solid #cae5fd;
		border-radius: 50%;
	}
	.user-name {
		color: #475569;
	}
	a {
		margin: 14px 0 0 0;
	}
}
.uinfo-idbox {
	flex: 1 1;
	dl {
		margin: 12px 0;
	}
	dd {
		margin-left: 20px;
	}
}
.extinfo-box {
	padding: 40px 20px 120px;
}
.extinfo-content {
	margin-top: 40px;
	h4 {
		margin: 0;
		font-weight: 400;
		font-size: 20px;
	}
	p {
		margin: 15px 0 45px;
		color: #888888;
	}
}
/deep/ .el-link.el-link--primary {
	color: #155dfc;
}
/deep/ .el-link.is-underline:hover:after {
	border-bottom: none;
}
//媒体查询-pad
@media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
	.uinfo-box {
		padding: 15px;
	}
	.uinfo-wrap {
		width: 45%;
		.avatar-box {
			width: 78px;
			height: 78px;
		}
	}
	.uinfo-idbox {
		flex: none;
	}
	/deep/ .el-avatar--circle {
		width: 78px !important;
		height: 78px !important;
		line-height: 78px !important;
	}
}
</style>
